// removed by extract-text-webpack-plugin
module.exports = {"component":"_3WEuMHwsZKPcq_CXATBL6S","warningContainer":"_2nW1HOxrtNCQYsuszH88TQ","title":"_3JR84XwsuZ-9z2N78PmAUI","content":"_14s8lcG1v1lNe7Oqq2avWl"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/WarningPage/WarningPage.scss
 ** module id = 1043
 ** module chunks = 0
 **/